import styled from "styled-components";

import { theme } from "theme/theme";

export const WrapperContent = styled.div`
  position: relative;
  padding: 7px 16px 16px;
  margin-top: -8px;
  .csv-button {
    position: absolute;
    right: 2px;
    top: -48px;
  }
  ${theme.media.tablet} {
    margin-top: 0px;
    padding: 16px;
    .csv-button {
      top: -55px;
    }
  }
  ${theme.media.desktop} {
    padding: 24px;
  }
`;

export const SectionLabel = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #1a2f62;
  margin-bottom: 8px;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  ${theme.media.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const ItemSingle = styled.div`
  width: 100%;
  padding: 12px 20.5px 7px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  .title {
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    color: #3b3b3b;
    margin-bottom: 12px;
  }
  .total-count {
    font-family: Noto Sans JP;

    width: 100%;
    text-align: center;
    font-weight: 700;
    color: #1a2f62;
    font-size: 24px;
    line-height: 14px;
    margin-bottom: 12px;
    .human {
      font-weight: 500;
      font-size: 14px;
      color: #3b3b3b;
    }
  }
  .seperate-count {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    gap: 2px;
    color: #666666;
    width: 100%;
  }
  ${theme.media.tablet} {
    width: max-content;
    min-width: 206px;
  }
`;

export const ItemDouble = styled.div<{ hasMargin?: boolean }>`
  position: relative;
  width: 100%;
  display: inline-block;
  margin-top: ${({ hasMargin }) => (hasMargin ? "28px" : "0")};
  transition: margin-top 0.2s ease;

  .wrapper {
    border: 1px solid #cccccc;
    border-radius: 10px;
    display: flex;
    position: relative;
    align-items: center;
    background-color: #ffffff;
    gap: 24px;
    z-index: 1;
    width: 100%;
    padding: 12px 23px 7px;
    .child-item {
      width: 50%;
      min-width: 174px;
      .title {
        width: 100%;
        text-align: center;
        font-size: 18px;
        line-height: 18px;
        font-weight: 700;
        color: #3b3b3b;
        margin-bottom: 12px;
      }
      .total-count {
        font-family: Noto Sans JP;

        width: 100%;
        text-align: center;
        font-weight: 700;
        color: #1a2f62;
        font-size: 24px;
        line-height: 14px;
        margin-bottom: 12px;
        .human {
          font-weight: 500;
          font-size: 14px;
          color: #3b3b3b;
        }
      }
      .seperate-count {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        gap: 2px;
        color: #666666;
        width: 100%;
      }
    }
    .divider {
      position: absolute;
      height: 70px;
      left: 50%;
      top: 12px;
      border: 1px solid #cccccc;
      border-right: none;
    }
  }
  .upper-label {
    border-radius: 12px 12px 0px 0px;
    background-color: #f2f2f2;
    padding: 6px 8px 14px;
    position: absolute;
    left: 0px;
    top: -28px;
    z-index: 0;
    font-family: Noto Sans JP;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #666666;
    width: 100%;
    display: none;
  }
  ${theme.media.tablet} {
    width: max-content;
    .upper-label {
      display: block;
    }
  }
`;

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.text.primary,
  fontWeight: theme.fontWeight.bold,
  fontSize: theme.sizes.md,
  lineHeight: "23px",
  marginBottom: 24,
  marginRight: 4,
}));

export const WrapperTab = styled.div`
  display: flex;
  justify-content: left;
  margin-left: 16px;
  gap: 16px;
  /* ${theme.media.tablet} {
    justify-content: end;
  } */
`;

export const ItemTab = styled.div`
  /* margin: 0px 4px; */
  float: left;
  :hover {
    cursor: pointer;
  }
  div {
    width: 140px;
    text-align: center;
    padding: 0px 12px;
    border-radius: 8px 8px 0px 0px;
    height: 48px;
    line-height: 48px;
    /* margin-top: 4px; */
    background: #e0e0e0;
    font-weight: ${theme.fontWeight.bold};
    font-size: ${theme.sizes.lg};
    text-align: center;
    color: #666666;
    transition: background 0.3s ease, color 0.3s ease;
  }
  .tab-active {
    background: #ffffff;
    margin-top: 0px;
    height: 48px !important;
    line-height: 48px !important;
    color: #3b3b3b;
  }
`;

export const WrapperTabs = styled.div`
  ${theme.media.desktop} {
    display: flex;
    justify-content: space-between;
  }
`;

export const WrapperDashboardContent = styled.div`
  border-radius: 8px;
  background-color: #ffffff;
  padding: 16px 24px 48px;
`;

export const WrapperPagination = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  > svg {
    margin-top: 8px;
  }

  ${theme.media.tablet} {
    gap: 16px;
  }
  ${theme.media.tabletL} {
    gap: 24px;
  }
`;

export const YearMonthPagination = styled.div`
  display: flex;
  gap: 12px;
  flex: 1;
`;

export const PaginationItem = styled.div<{ collapsed?: boolean }>`
  padding: 12px 12px 14px;
  height: max-content;

  border-radius: 8px;
  background-color: #f2f2f2;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  /* width: ${({ collapsed }) => (collapsed ? "524px" : "103px")}; */
  min-width: 103px;
  transition: all 0.3s ease;

  .label {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .months {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    /* height: 30px; */
    height: ${({ collapsed }) => (collapsed ? "max-content" : "0px")};
    width: ${({ collapsed }) => (collapsed ? "max-content" : "0px")};
    opacity: ${({ collapsed }) => (collapsed ? 1 : 0)};
    transition: all 0.3s ease;
    max-width: 114px;
    flex-wrap: wrap;

    .month-item {
      height: ${({ collapsed }) => (collapsed ? "30px" : "0px")};
      width: ${({ collapsed }) => (collapsed ? "30px" : "0px")};
      color: #2ac769;
      border: 1px solid #2ac769;
      border-radius: 4px;
      background-color: #ffffff;
      font-size: 15px;
      line-height: 15px;
      padding: 8px 0px 7px;
      text-align: center;
      cursor: pointer;
      font-weight: 700;
    }
    .active {
      background-color: #2ac769;
      color: #ffffff;
      border: 1px solid #ffffff;
    }
    .disabled {
      color: #cccccc;
      border: 1px solid #cccccc;
      background-color: #f2f2f2;
      cursor: default;
      user-select: none;
    }
  }

  ${theme.media.mobileXL} {
    .months {
      max-width: 240px;
    }
  }

  ${theme.media.tabletL} {
    padding: 16px 16px 18px;
  }

  ${theme.media.desktop} {
    .months {
      max-width: unset;
      height: ${({ collapsed }) => (collapsed ? "30px" : "0px")};
    }
  }
`;

export const ContentTableLeft = styled.div<{ loading?: boolean }>`
  border: 1px solid #cccccc;
  width: max-content;
  display: flex;
  position: relative;
  /* opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")}; */
  .title-line {
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    color: #3b3b3b;
    border-bottom: 1px solid #cccccc;
    div:nth-child(2) {
      text-align: center;
      background-color: #e0e0e0;
      min-width: 241px;
    }
    div:nth-child(3) {
      min-width: 112px;
    }
    div:nth-child(4) {
      min-width: 124px;
    }
    div:first-child {
      background-color: #e0e0e0;
    }
    div {
      padding: 7px 5px 7px;
    }
    div:not(:last-child) {
      border-right: 1px solid #cccccc;
    }
  }
  .unit-line {
    display: flex;
    width: max-content;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    background-color: #f2f2f2;
    border-bottom: 1px solid #cccccc;
    div {
      padding: 5px;
    }
    div:first-child {
      width: 37px;
    }
    div:nth-child(2) {
      width: 134px;
    }
    div:nth-child(3) {
      width: 60px;
    }
    div:nth-child(4) {
      width: 47px;
    }
    div:nth-child(5) {
      min-width: 112px;
    }
    div:nth-child(6) {
      min-width: 124px;
    }
  }

  .first-block {
    min-width: 83.5px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    color: #3b3b3b;
    div {
      padding: 5px 5px 4px;
    }
    div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
    }
    div:last-child {
      font-weight: 500;
      padding: 5px;
    }
    div:nth-child(2) {
      background-color: #f2f2f2;
      height: 24px;
      width: 100%;
    }
    div:nth-child(3) {
      height: 24px;
      width: 100%;
    }
    div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .second-block {
    min-width: 178px;
    width: max-content;
    border-right: 1px solid #cccccc;
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
      text-align: left;
      border-bottom: 1px solid #cccccc;
    }
    .block-1 {
      min-width: 134px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      border-right: 1px solid #cccccc;
      > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      }
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      > div:first-child {
        font-weight: 500;
      }
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 43px;
      }
      .col-3 {
        min-width: 66px;
      }
      .col-1,
      .col-2,
      .col-3 {
        pointer-events: none;
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
      .col-1 > div,
      .col-2 > div,
      .col-3 > div {
        pointer-events: auto; /* Re-enable on individual cells */
        user-select: text;
      }
    }
    .block-2 {
      min-width: 60px;
      width: max-content;
      border-right: 1px solid #cccccc;
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 700;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
    .block-3 {
      min-width: 44px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
  }
  .third-block,
  .fourth-block {
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      /* background-color: #e0e0e0; */
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }
  }

  .third-block {
    min-width: 112px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:first-child {
      text-align: left;
    }

    .block-2 {
      border-left: 1px solid #cccccc;
    }
    .block-1,
    .block-2 {
      min-width: 112px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      }
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      > div:first-child {
        font-weight: 500;
      }
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 43px;
      }
      .col-3 {
        min-width: 66px;
        text-align: center;
      }
      .col-1,
      .col-2,
      .col-3 {
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
    }

    /* > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 36px;
    }
    .col-3 {
      min-width: 40px;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    } */
  }
  .fourth-block {
    min-width: 124px;
    width: max-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 40px;
    }
    .col-3 {
      min-width: 44px;
      text-align: center;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    }
  }

  ${theme.media.laptopL} {
    .second-block {
      .block-1 {
        .col-1,
        .col-2 {
          min-width: 47px;
        }
      }
    }
    .third-block {
      .block-1,
      .block-2 {
        .col-1,
        .col-2 {
          min-width: 47px;
        }
      }
    }
  }
`;

export const ContentTableRight = styled.div<{ loading?: boolean }>`
  border: 1px solid #cccccc;
  width: max-content;
  display: flex;
  position: relative;
  /* opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")}; */
  .first-block {
    min-width: 83.5px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    color: #3b3b3b;
    div {
      padding: 5px 5px 4px;
    }
    div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
    }
    /* div:last-child {
      font-weight: 500;
      padding: 5px;
    } */
    div:nth-child(2) {
      background-color: #f2f2f2;
      height: 24px;
      width: 100%;
    }
    div:nth-child(3) {
      height: 23px;
      width: 100%;
    }
    div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .second-block {
    min-width: 134px;
    width: max-content;
    border-right: 1px solid #cccccc;
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
      text-align: left;
      border-bottom: 1px solid #cccccc;
    }
    .block-1 {
      min-width: 134px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* border-right: 1px solid #cccccc; */
      > div:first-child {
        height: 24px;
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      }
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      > div:first-child {
        font-weight: 500;
      }
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 43px;
      }
      .col-3 {
        min-width: 40px;
      }
      .col-1,
      .col-2,
      .col-3 {
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        /* > div:last-child {
          font-weight: 500;
          padding: 5px;
        } */
      }
    }
    .block-2 {
      min-width: 55px;
      width: max-content;
      /* border-right: 1px solid #cccccc; */
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        height: 24px;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      /* > div:last-child {
        font-weight: 700;
        padding: 5px;
      } */
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
    .block-3 {
      min-width: 47px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      /* > div:last-child {
        font-weight: 500;
        padding: 5px;
      } */
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
  }
  .third-block,
  .fourth-block {
    > div:first-child {
      height: 31px;
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      /* background-color: #e0e0e0; */
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }
  }

  .third-block {
    min-width: 112px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:first-child {
      text-align: left;
    }

    > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 43px;
    }
    .col-3 {
      min-width: 40px;
      text-align: center;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      /* > div:last-child {
        font-weight: 500;
        padding: 5px;
      } */
    }
  }
  .fourth-block {
    min-width: 112px;
    width: max-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 43px;
    }
    .col-3 {
      min-width: 40px;
      text-align: center;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      /* > div:last-child {
        font-weight: 500;
        padding: 5px;
        text-align: center;
      } */
    }
  }
  ${theme.media.laptopL} {
    .second-block {
      .block-1 {
        .col-1,
        .col-2 {
          min-width: 47px;
        }
      }
    }
    .third-block {
      .col-1,
      .col-2 {
        min-width: 47px;
      }
    }
    .fourth-block {
      .col-1,
      .col-2 {
        min-width: 47px;
      }
    }
  }
`;

export const TableContent = styled.div<{ isFullWidth?: boolean }>`
  width: 100%;

  ${theme.media.tabletL} {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }
  @media screen and (max-width: 1200px) {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }

  @media screen and (min-width: 1247px) {
    width: max-content;
  }
`;

export const TitlePopupWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 24px;
  margin-bottom: 16px;
  .title-popup {
    margin-right: 1px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #3b3b3b;
  }
  .popup-btn {
    min-width: 128px;
    height: 31px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 7px 8px 7px 4px;
    background-color: #2ac769;
    border-radius: 4px;
    .name {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: #ffffff;
    }
  }
  .disabled-btn {
    background-color: #cccccc;
    cursor: no-drop;
    svg {
      cursor: no-drop;
    }
  }
`;

export const TableWrapper = styled.div<{
  isHouseholdBasedConsultation?: boolean;
  desktopDisplay?: boolean;
}>`
  display: flex;
  gap: 24px;
  flex-direction: column;
  ${theme.media.laptop} {
    /* flex-direction: ${({ isHouseholdBasedConsultation }) =>
      isHouseholdBasedConsultation ? "column" : "row"}; */
    flex-direction: "column";
  }
  /* ${theme.media.laptopL} {
    flex-direction: ${({ desktopDisplay }) =>
    desktopDisplay ? "column" : "row"};
  }
  flex-direction: row;
  } */
  @media screen and (min-width: 1360px) {
    flex-direction: ${({ desktopDisplay }) =>
      desktopDisplay ? "column" : "row"};
  }
  /* ${theme.media.desktopL} {
    flex-direction: row;
  } */
  @media screen and (min-width: 1850px) {
    flex-direction: row;
  }
`;

export const LeftTableLineItem = styled.div`
  display: flex;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-bottom: 1px solid #cccccc;
  div {
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 4px 5px;
  }
  div:last-child {
    border-right: none;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-47 {
    min-width: 47px;
  }
  .width-44 {
    min-width: 44px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
`;

export const RightTableLineItem = styled.tr`
  display: flex;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  /* border-right: 1px solid #cccccc; */
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 4px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-47 {
    min-width: 43px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66 {
    min-width: 67px;
  }

  ${theme.media.laptopL} {
    .width-47 {
      min-width: 47px;
    }
  }
`;

export const RightTableLastLineItem = styled.tr`
  display: flex;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  /* border-right: 1px solid #cccccc; */
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 5px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
    min-width: 83.5px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-47 {
    min-width: 43px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66 {
    min-width: 67px;
  }
  ${theme.media.laptopL} {
    .width-47 {
      min-width: 47px;
    }
  }
`;

export const TableLoadingWrapper = styled.div<{
  loading?: boolean;
  isOverflowing?: boolean;
  showShadowRight?: boolean;
  showShadowLeft?: boolean;
  leftTable?: boolean;
}>`
  position: relative;
  opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")};
  overflow: ${(props) => (props.isOverflowing ? "auto" : "hidden")};
  width: ${(props) => (props.isOverflowing ? "100%" : "max-content")};
  box-shadow: ${(props) =>
    props.showShadowRight || props.showShadowLeft
      ? props.showShadowRight
        ? "inset -32px 0 32px -16px rgba(0,0,0,0.12)"
        : "inset 32px 0 32px -16px rgba(0,0,0,0.12)"
      : "none"};
  transition: "box-shadow 0.2s ease";
  order: 2;
  @media screen and (min-width: 1400px) {
    order: 1;
  }
  @media screen and (min-width: 1400px) {
    /* width: ${({ leftTable }) => (leftTable ? "100%" : "max-content")}; */
    width: max-content;
  }
`;

export const ContentTableLeft2 = styled.div<{
  loading?: boolean;
  isHouseholdBased?: boolean;
}>`
  border: 1px solid #cccccc;
  background-color: #ffffff;
  width: 100%;
  @media screen and (min-width: 1400px) {
    width: 100%;
  }
  display: flex;
  position: relative;
  transform: translate3d(0, 0, 0);
  will-change: transform;
  transition: box-shadow 0.2s ease;
  order: 2;
  /* opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")}; */
  .title-line {
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    color: #3b3b3b;
    border-bottom: 1px solid #cccccc;
    div:nth-child(2) {
      text-align: center;
      background-color: #e0e0e0;
      min-width: 241px;
    }
    div:nth-child(3) {
      min-width: 112px;
    }
    div:nth-child(4) {
      min-width: 124px;
    }
    div:first-child {
      background-color: #e0e0e0;
    }
    div {
      padding: 7px 5px 7px;
    }
    div:not(:last-child) {
      border-right: 1px solid #cccccc;
    }
  }
  .unit-line {
    display: flex;
    width: max-content;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    background-color: #f2f2f2;
    border-bottom: 1px solid #cccccc;
    div {
      padding: 5px;
    }
    div:first-child {
      width: 37px;
    }
    div:nth-child(2) {
      width: 134px;
    }
    div:nth-child(3) {
      width: 60px;
    }
    div:nth-child(4) {
      width: 47px;
    }
    div:nth-child(5) {
      min-width: 112px;
    }
    div:nth-child(6) {
      min-width: 124px;
    }
  }
  .middle-block {
    min-width: 85px;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    width: max-content;
    color: #3b3b3b;
    div {
      padding: 5px 5px 4px;
      text-align: center;
    }
    div:first-child {
      font-weight: 500;
      padding: 20px 0px;
      font-size: 14px;
      line-height: 14px;
    }
    > div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
    @media screen and (min-width: 1400px) {
      width: 105px;
      /* width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc((100% - 183px) / 15)"
          : "calc((100% - 183px) / 12)"}; */
    }
  }
  .first-block {
    min-width: 184px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    color: #3b3b3b;
    padding: 19px 10px;
    text-align: center;
    background-color: #ffffff;
    div {
      padding: 5px 5px 4px;
    }
    div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
    }
    div:last-child {
      font-weight: 500;
      padding: 5px;
    }
    div:nth-child(2) {
      background-color: #f2f2f2;
      height: 24px;
      width: 100%;
    }
    div:nth-child(3) {
      height: 24px;
      width: 100%;
    }
    div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .pink {
    background-color: #fed5d5 !important;
    div {
      background-color: #fed5d5 !important;
    }
  }
  .blue {
    background-color: #d0e8f0 !important;
    div {
      background-color: #d0e8f0 !important;
    }
  }
  .yellow {
    background-color: #faf0c2 !important;
    div {
      background-color: #faf0c2 !important;
    }
  }
  .green {
    background-color: #cef4de !important;
    div {
      background-color: #cef4de !important;
    }
  }
  .grey {
    background-color: #e5e7eb !important;
    div {
      background-color: #e5e7eb !important;
    }
  }
  .single-block {
    min-width: 105px;
    width: max-content;
    border-right: 1px solid #cccccc;
    div {
      font-weight: 500;
      text-align: left;
    }
    > div:first-child {
      padding: 7px 15px 7px;
      font-size: 16px;
      line-height: 16px;
      border-bottom: 1px solid #cccccc;
    }
    > div:last-child {
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      padding: 5px;
    }
  }
  .second-block {
    /* min-width: 178px; */
    min-width: max-content;
    /* @media screen and (min-width: 1400px) {
      width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 184px) / 15) * 4)"
        : "calc(((100% - 184px) / 12) * 4)"};
    } */
    border-right: 1px solid #cccccc;
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
      text-align: left;
      border-bottom: 1px solid #cccccc;
    }
    .block-1 {
      min-width: 134px;
      @media screen and (min-width: 1400px) {
        min-width: 100%;
      }
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* border-right: 1px solid #cccccc; */
      /* > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      } */
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      > div:first-child {
        font-weight: 500;
      }
      > div:first-child {
        text-align: center;
      }
      .col-0,
      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 80px !important;
        /* @media screen and (min-width: 1625px) {
          min-width: 72px !important;
          } */
        @media screen and (min-width: 1400px) {
          min-width: 85px !important;
        }
        @media screen and (min-width: 1625px) {
          /* min-width: calc((100% / 4) - 3px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 4) !important;
        } */
      }
      .col-3 {
        min-width: 80px !important;
        /* @media screen and (min-width: 1400px) { */
        @media screen and (min-width: 1400px) {
          min-width: 85px !important;
        }
        @media screen and (min-width: 1625px) {
          /* min-width: calc((100% / 4) + 9px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 4) !important;
        } */
      }
      .col-4 {
        min-width: 81px !important;
        /* @media screen and (min-width: 1400px) { */
        @media screen and (min-width: 1400px) {
          min-width: 86px !important;
        }
        @media screen and (min-width: 1625px) {
          /* min-width: calc((100% / 4) + 9px) !important; */
          min-width: 106px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 4) !important;
        } */
      }
      .col-0,
      .col-1,
      .col-2,
      .col-3,
      .col-4 {
        pointer-events: none;
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
          background-color: #f2f2f2;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:not(:first-child) {
          text-align: right;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
      .col-1 > div,
      .col-2 > div,
      .col-3 > div,
      .col-4 > div {
        pointer-events: auto; /* Re-enable on individual cells */
        user-select: text;
      }
    }
    .block-2 {
      min-width: 60px;
      width: max-content;
      /* border-right: 1px solid #cccccc; */
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 700;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
    .block-3 {
      min-width: 44px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
  }
  .third-block,
  .fourth-block {
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      /* background-color: #e0e0e0; */
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }
  }

  .third-block {
    /* min-width: 112px; */
    min-width: max-content;
    /* @media screen and (min-width: 1400px) {
      width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 184px) / 15) * 3)"
        : "calc(((100% - 184px) / 12) * 3)"};
    } */
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:first-child {
      text-align: left;
    }

    .block-2 {
      border-left: 1px solid #cccccc;
    }
    .block-1,
    .block-2 {
      min-width: 112px;
      width: max-content;
      @media screen and (min-width: 1400px) {
        min-width: 100%;
      }
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      } */
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      /* > div:first-child {
        font-weight: 500;
      } */
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 85px !important;
        /* @media screen and (min-width: 1625px) {
          min-width: 72px !important;
        } */
        @media screen and (min-width: 1400px) {
          /* min-width: calc((100% / 3) - 4.5px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 3) !important;
        } */
      }
      .col-3 {
        min-width: 85px !important;
        text-align: center;
        /* @media screen and (min-width: 1400px) { */
        @media screen and (min-width: 1400px) {
          /* min-width: calc((100% / 3) + 9px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 3) !important;
        } */
      }
      .col-1,
      .col-2,
      .col-3 {
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
          background-color: #f2f2f2;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:first-child) {
          text-align: right;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
    }

    /* > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 36px;
    }
    .col-3 {
      min-width: 40px;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    } */
  }

  .third-block-2 {
    /* min-width: 112px; */
    min-width: max-content;
    flex: 1;
    @media screen and (min-width: 1400px) {
      flex: initial;
      /* width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 184px) / 15) * 4) !important"
          : "calc(((100% - 184px) / 12) * 4) !important"}; */
    }

    .block-1,
    .block-2 {
      min-width: 112px;
      width: max-content;
      @media screen and (min-width: 1400px) {
        min-width: 100%;
      }
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      } */
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      /* > div:first-child {
        font-weight: 500;
      } */
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 85px !important;
        /* @media screen and (min-width: 1625px) {
          min-width: 72px !important;
        } */
        @media screen and (min-width: 1400px) {
          /* min-width: calc((100% / 4) - 4.5px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 4) !important;
        } */
      }
      .col-3 {
        min-width: 84px !important;
        text-align: center;
        /* @media screen and (min-width: 1400px) { */
        @media screen and (min-width: 1400px) {
          /* min-width: calc(100% / 4) !important; */
          min-width: 105px !important;
        }
      }
      .col-3-2 {
        min-width: 84px !important;
        text-align: center;
        /* @media screen and (min-width: 1400px) { */
        @media screen and (min-width: 1400px) {
          /* min-width: calc((100% / 4) + 9px) !important; */
          min-width: 105px !important;
        }
        /* @media screen and (min-width: 1509px) {
          min-width: calc(100% / 4) !important;
        } */
      }
    }
  }
  .fourth-block {
    /* min-width: 124px; */
    min-width: max-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 40px;
    }
    .col-3 {
      min-width: 44px;
      text-align: center;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    }
  }

  ${theme.media.laptopL} {
    .second-block {
      .block-1 {
        .col-1,
        .col-2 {
          min-width: 85px;
        }
      }
    }
    .third-block {
      .block-1,
      .block-2 {
        .col-1,
        .col-2 {
          min-width: 85px;
        }
      }
    }
  }
  @media screen and (min-width: 1400px) {
    order: 1;
  }
`;

export const ContentTableRight2 = styled.div<{ loading?: boolean }>`
  border: 1px solid #cccccc;
  background-color: #ffffff;
  width: max-content;
  display: flex;
  position: relative;
  transform: translate3d(0, 0, 0);
  will-change: transform;
  transition: box-shadow 0.2s ease;
  /* opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")}; */
  .title-line {
    display: flex;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: left;
    color: #3b3b3b;
    border-bottom: 1px solid #cccccc;
    div:nth-child(2) {
      text-align: center;
      background-color: #e0e0e0;
      min-width: 241px;
    }
    div:nth-child(3) {
      min-width: 112px;
    }
    div:nth-child(4) {
      min-width: 124px;
    }
    div:first-child {
      background-color: #e0e0e0;
    }
    div {
      padding: 7px 5px 7px;
    }
    div:not(:last-child) {
      border-right: 1px solid #cccccc;
    }
  }
  .unit-line {
    display: flex;
    width: max-content;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    background-color: #f2f2f2;
    border-bottom: 1px solid #cccccc;
    div {
      padding: 5px;
    }
    div:first-child {
      width: 37px;
    }
    div:nth-child(2) {
      width: 134px;
    }
    div:nth-child(3) {
      width: 60px;
    }
    div:nth-child(4) {
      width: 47px;
    }
    div:nth-child(5) {
      min-width: 112px;
    }
    div:nth-child(6) {
      min-width: 124px;
    }
  }
  .middle-block {
    min-width: 73px;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    width: max-content;
    color: #3b3b3b;
    div {
      padding: 5px 5px 4px;
      text-align: right;
    }
    div:first-child {
      font-weight: 500;
      padding: 20px 0px;
      font-size: 14px;
      line-height: 14px;
    }
    > div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .first-block {
    min-width: 184px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0px;
    color: #3b3b3b;
    padding: 19px 10px;
    text-align: center;
    background-color: #ffffff;
    div {
      padding: 5px 5px 4px;
    }
    div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px 8px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
    }
    div:last-child {
      font-weight: 500;
      padding: 5px;
    }
    div:nth-child(2) {
      background-color: #f2f2f2;
      height: 24px;
      width: 100%;
    }
    div:nth-child(3) {
      height: 24px;
      width: 100%;
    }
    div:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .pink {
    background-color: #fed5d5 !important;
    div {
      background-color: #fed5d5 !important;
    }
  }
  .blue {
    background-color: #d0e8f0 !important;
    div {
      background-color: #d0e8f0 !important;
    }
  }
  .yellow {
    background-color: #faf0c2 !important;
    div {
      background-color: #faf0c2 !important;
    }
  }
  .green {
    background-color: #cef4de !important;
    div {
      background-color: #cef4de !important;
    }
  }
  .grey {
    background-color: #e5e7eb !important;
    div {
      background-color: #e5e7eb !important;
    }
  }
  .single-block {
    min-width: 86px;
    width: max-content;
    border-right: 1px solid #cccccc;
    div {
      font-weight: 500;
      text-align: left;
    }
    > div:first-child {
      padding: 7px 15px 7px;
      font-size: 16px;
      line-height: 16px;
      border-bottom: 1px solid #cccccc;
    }
    > div:last-child {
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      padding: 5px;
    }
  }
  .second-block {
    min-width: 178px;
    width: max-content;
    border-right: 1px solid #cccccc;
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      background-color: #e0e0e0;
      text-align: left;
      border-bottom: 1px solid #cccccc;
    }
    .block-1 {
      min-width: 134px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* border-right: 1px solid #cccccc; */
      /* > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      } */
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      > div:first-child {
        font-weight: 500;
      }
      > div:first-child {
        text-align: center;
      }
      .col-0 {
        border-right: 1px solid #cccccc;
        min-width: 60px;
        @media screen and (min-width: 1360px) {
          min-width: 72px !important;
        }
        @media screen and (min-width: 1735px) {
          min-width: 85px !important;
        }
      }
      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 64px;
        @media screen and (min-width: 1360px) {
          min-width: 72px !important;
        }
        @media screen and (min-width: 1735px) {
          min-width: 85px !important;
        }
      }
      .col-3 {
        min-width: 72px;
        @media screen and (min-width: 1735px) {
          min-width: 84px;
        }
      }
      .col-0,
      .col-1,
      .col-2,
      .col-3 {
        pointer-events: none;
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
          background-color: #f2f2f2;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:not(:first-child) {
          text-align: right;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
      .col-1 > div,
      .col-2 > div,
      .col-3 > div {
        pointer-events: auto; /* Re-enable on individual cells */
        user-select: text;
      }
    }
    .block-2 {
      min-width: 60px;
      width: max-content;
      /* border-right: 1px solid #cccccc; */
      font-weight: 500;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 700;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
    .block-3 {
      min-width: 44px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      div {
        padding: 5px 5px 4px;
      }
      > div:first-child {
        font-weight: 500;
        text-align: center;
        background-color: #f2f2f2;
      }
      > div:nth-child(2) {
        height: 24px;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
    }
  }
  .third-block,
  .fourth-block {
    > div:first-child {
      font-weight: 500;
      padding: 7px 5px 7px;
      font-size: 16px;
      line-height: 16px;
      /* background-color: #e0e0e0; */
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }
  }

  .third-block {
    min-width: 112px;
    width: max-content;
    border-right: 1px solid #cccccc;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:first-child {
      text-align: left;
    }

    .block-2 {
      border-left: 1px solid #cccccc;
    }
    .block-1,
    .block-2 {
      min-width: 112px;
      width: max-content;
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      letter-spacing: 0px;
      text-align: right;
      /* > div:first-child {
        padding: 5px 5px 4px;
        border-bottom: 1px solid #cccccc;
        background-color: #f2f2f2;
      } */
      /* > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      } */
      /* > div:first-child {
        font-weight: 500;
      } */
      > div:first-child {
        text-align: center;
      }

      .col-1,
      .col-2 {
        border-right: 1px solid #cccccc;
        min-width: 64px;
        @media screen and (min-width: 1360px) {
          min-width: 72px !important;
        }
        @media screen and (min-width: 1735px) {
          min-width: 85px !important;
        }
      }
      .col-3 {
        min-width: 72px;
        text-align: center;
        @media screen and (min-width: 1735px) {
          min-width: 84px;
        }
      }
      .col-1,
      .col-2,
      .col-3 {
        width: max-content;
        > div:first-child {
          text-align: center;
          font-weight: 500;
          background-color: #f2f2f2;
        }
        > div {
          padding: 5px 5px 4px;
        }
        > div:not(:first-child) {
          text-align: right;
        }
        > div:not(:last-child) {
          border-bottom: 1px solid #cccccc;
        }
        > div:last-child {
          font-weight: 500;
          padding: 5px;
        }
      }
    }

    /* > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 36px;
    }
    .col-3 {
      min-width: 40px;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    } */
  }
  .fourth-block {
    min-width: 124px;
    width: max-content;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    text-align: right;

    > div:nth-child(2) {
      font-weight: 500;
      padding: 5px 5px 4px;
      background-color: #f2f2f2;
      text-align: center;
      border-bottom: 1px solid #cccccc;
    }

    .col-1,
    .col-2 {
      border-right: 1px solid #cccccc;
      min-width: 40px;
    }
    .col-3 {
      min-width: 44px;
      text-align: center;
    }
    .col-1,
    .col-2,
    .col-3 {
      width: max-content;
      > div:first-child {
        text-align: center;
        font-weight: 500;
      }
      > div {
        padding: 5px 5px 4px;
      }
      > div:not(:last-child) {
        border-bottom: 1px solid #cccccc;
      }
      > div:last-child {
        font-weight: 500;
        padding: 5px;
      }
    }
  }

  ${theme.media.laptopL} {
    .second-block {
      .block-1 {
        .col-1,
        .col-2 {
          min-width: 64px;
        }
      }
    }
    .third-block {
      .block-1,
      .block-2 {
        .col-1,
        .col-2 {
          min-width: 64px;
        }
      }
    }
  }
`;

export const TableContent2 = styled.div<{
  isFullWidth?: boolean;
}>`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  flex-direction: column;

  ${theme.media.tabletL} {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }
  @media screen and (max-width: 1200px) {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }

  @media screen and (min-width: 1247px) {
    /* width: max-content; */
  }
  @media screen and (min-width: 1400px) {
    width: max-content;
    flex-direction: column-reverse;
  }
`;

export const TableContent3 = styled.div<{ isFullWidth?: boolean }>`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  flex-direction: column;

  ${theme.media.tabletL} {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }
  @media screen and (max-width: 1200px) {
    width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "max-content")};
  }

  @media screen and (min-width: 1247px) {
    /* width: max-content; */
  }
  @media screen and (min-width: 1400px) {
    width: max-content;
    flex-direction: column-reverse;
  }
`;

export const TitlePopupWrapper2 = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  flex-direction: column;
  /* flex: 1; */
  order: 1;
  /* margin-bottom: 16px; */
  .title-popup {
    margin-right: 1px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: #3b3b3b;
  }
  .title-text {
    color: #3b3b3b;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
  .popup-btn {
    min-width: 128px;
    height: 31px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 7px 8px 7px 4px;
    background-color: #2ac769;
    border-radius: 4px;
    .name {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
      color: #ffffff;
    }
  }
  .disabled-btn {
    background-color: #cccccc;
    cursor: no-drop;
    svg {
      cursor: no-drop;
    }
  }
  @media screen and (min-width: 834px) {
    flex-direction: row;
    align-items: center;
    gap: 24px;
    .title-text {
      line-height: 14px;
    }
  }
  @media screen and (min-width: 1400px) {
    order: 2;
  }
`;

export const RightTableLineItem2 = styled.tr<{ isHouseholdBased?: boolean }>`
  display: flex;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 4px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-46 {
    min-width: 46px;
  }
  .width-47 {
    min-width: 47px;
  }
  .width-72,
  .width-72-block-1,
  .width-72-block-2,
  .width-72-block-3-1,
  .width-72-block-3-2 {
    min-width: 80px;
    /* min-width: 47px; */
  }
  .width-72-block-1 {
    min-width: 105px;
  }
  .width-82 {
    min-width: 115px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66,
  .width-66-none,
  .width-66-middle,
  .width-66-none-block-1 {
    /* min-width: 73px; */
    min-width: 80px;
  }
  .width-66-none-block-2,
  .width-66-none-block-3 {
    min-width: 81px;
  }
  .width-66:last-child {
    border-right: none;
  }

  .width-183 {
    min-width: 184px;
    text-align: left !important;
    padding-left: 8px !important;
  }

  @media screen and (min-width: 1400px) {
    .width-72,
    /* .width-72-block-1, */
    .width-72-block-2,
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: 85px;
      /* min-width: 47px; */
    }
    .width-66,
    .width-66-none,
    .width-66-middle,
    .width-66-none-block-1 {
      /* min-width: 73px; */
      min-width: 85px;
    }
    .width-66-none-block-2,
    .width-66-none-block-3 {
      min-width: 86px;
    }
  }
  @media screen and (min-width: 1625px) {
    .width-72 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) - 4px)"
          : "calc(((100% - 185px) / 12) - 4px)"}; */
    }
    .width-72-block-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 199px) / 15) - 3px)"
          : "calc(((100% - 199px) / 12) - 3px)"}; */
    }
    .width-72-block-2 {
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 208px) / 15) - 4.5px)"
          : "calc(((100% - 208px) / 12) - 4.5px)"}; */
      min-width: 105px;
    }
    .width-72-block-3-1,
    .width-72-block-3-2 {
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 208px) / 15) - 3.5px)"
          : "calc(((100% - 208px) / 12) - 3.5px)"}; */
      min-width: 105px;
    }
    .width-66-none-block-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 9px)"
          : "calc(((100% - 185px) / 12) + 9px)"}; */
    }
    .width-66-none-block-2 {
      min-width: 106px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 9px)"
          : "calc(((100% - 185px) / 12) + 9px)"}; */
    }
    .width-66-none-block-3 {
      min-width: 106px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 8px)"
          : "calc(((100% - 185px) / 12) + 8px)"}; */
    }
    .width-72-2 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 184px) / 15) - 6px)"
          : "calc(((100% - 184px) / 12) - 6px)"}; */
    }
    .width-72-3 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 184px) / 15) - 6px)"
          : "calc(((100% - 184px) / 12) - 6px)"}; */
    }

    .width-66-none-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 178px) / 15) + 9px)"
          : "calc(((100% - 178px) / 12) + 9px)"}; */
    }
    .width-66-middle {
      min-width: 105px;
      /* min-width: 73px;
      width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc((100% - 182px) / 15)"
          : "calc((100% - 182px) / 12)"}; */
    }
    .width-66 {
      min-width: 105px;
      /* min-width: 73px;
      width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc((100% - 178px) / 15)"
          : "calc((100% - 178px) / 12)"}; */
    }
    .width-66:last-child {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 173px) / 15) - 4px)"
          : "calc(((100% - 173px) / 12) - 4px)"}; */
    }
  }
  /* @media screen and (min-width: 1450px) {
    .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 195px) / 15) - 3px)"
      : "calc(((100% - 195px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 204px) / 15) - 4.5px)"
      : "calc(((100% - 204px) / 12) - 4.5px)"};
    }
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 208px) / 15) - 3.5px)"
      : "calc(((100% - 208px) / 12) - 3.5px)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 187px) / 15) + 9px)"
      : "calc(((100% - 187px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 178px) / 15) + 9px)"
      : "calc(((100% - 178px) / 12) + 9px)"};
    }
  }
  @media screen and (min-width: 1475px) {
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 197px) / 15) - 4.5px)"
      : "calc(((100% - 197px) / 12) - 4.5px)"};
    }
  }
  @media screen and (min-width: 1500px) {
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 191px) / 15) - 4.5px)"
      : "calc(((100% - 191px) / 12) - 4.5px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 219px) / 15) - 3.5px)"
      : "calc(((100% - 219px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 210px) / 15) - 3.5px)"
      : "calc(((100% - 210px) / 12) - 3.5px)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 170px) / 15) + 8px)"
      : "calc(((100% - 170px) / 12) + 8px)"};
    }
  }
  @media screen and (min-width: 1509px) {
    .width-72,
    .width-72-block-1,
    .width-72-block-2,
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 193px) / 15)"
      : "calc((100% - 193px) / 12)"};
    }
    .width-66-none,
    .width-66-none-block-1,
    .width-66-none-block-2,
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 183px) / 15)"
      : "calc((100% - 183px) / 12)"};
    }
    .width-66:last-child {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 184px) / 15)"
      : "calc((100% - 184px) / 12)"};
    }
  }
  @media screen and (min-width: 1530px) {
    .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 145px) / 15) - 3px)"
      : "calc(((100% - 145px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 140px) / 15) - 3.5px)"
      : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 130px) / 15) - 3.5px)"
      : "calc(((100% - 130px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 140px) / 15) - 3.5px)"
      : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 318px) / 15) + 9px)"
      : "calc(((100% - 318px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 225px) / 15) + 3px)"
      : "calc(((100% - 225px) / 12) + 3px)"};
    }
  }
  @media screen and (min-width: 1550px) {
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 312px) / 15) + 9px)"
      : "calc(((100% - 312px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 222px) / 15) + 3px)"
      : "calc(((100% - 222px) / 12) + 3px)"};
    }
  }
  @media screen and (min-width: 1575px) {
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 300px) / 15) + 9px)"
      : "calc(((100% - 300px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 216px) / 15) + 3px)"
      : "calc(((100% - 216px) / 12) + 3px)"};
    }
  }
  @media screen and (min-width: 1600px) {
    .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 143px) / 15) - 3px)"
      : "calc(((100% - 143px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 125px) / 15) - 3.5px)"
      : "calc(((100% - 125px) / 12) - 3.5px)"};
    }
    .width-66-middle {
      width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 170px) / 15)"
      : "calc((100% - 170px) / 12)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 310px) / 15) + 9px)"
      : "calc(((100% - 310px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 234px) / 15) + 3px)"
      : "calc(((100% - 234px) / 12) + 3px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 128px) / 15) - 3.5px)"
      : "calc(((100% - 128px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 140px) / 15) - 3.5px)"
      : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc(((100% - 282px) / 15) + 7px)"
      : "calc(((100% - 282px) / 12) + 7px)"};
    }
  }
  @media screen and (min-width: 1735px) {
    .width-72,
    .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 185px) / 15)"
      : "calc((100% - 185px) / 12)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 187px) / 15)"
      : "calc((100% - 187px) / 12)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 180px) / 15)"
      : "calc((100% - 180px) / 12)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 182px) / 15)"
      : "calc((100% - 182px) / 12)"};
    }
    .width-66,
    .width-66-none,
    .width-66-none-block-1,
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 178px) / 15)"
      : "calc((100% - 178px) / 12)"};
    }
    .width-66-middle {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 188px) / 15)"
      : "calc((100% - 188px) / 12)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 183px) / 15)"
      : "calc((100% - 183px) / 12)"};
    }
    .width-66:last-child {
      min-width: ${({ isHouseholdBased }) =>
    isHouseholdBased
      ? "calc((100% - 184px) / 15)"
      : "calc((100% - 184px) / 12)"};
    }
  } */
  ${theme.media.laptopL} {
    /* .width-47 {
      min-width: 46px;
    } */
    /* .width-72 {
      min-width: 72px;
    } */
  }
`;

export const RightTableLineItem3 = styled.tr`
  display: flex;
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  /* border-right: 1px solid #cccccc; */
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 4px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-46 {
    min-width: 46px;
  }
  .width-47 {
    min-width: 47px;
  }
  .width-72 {
    min-width: 64px;
  }
  .width-72-single {
    min-width: 86px;
  }
  .width-82 {
    min-width: 115px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66 {
    min-width: 73px;
  }
  .width-183 {
    min-width: 184px;
    text-align: left !important;
    padding-left: 8px !important;
  }

  .width-126 {
    min-width: 127px;
  }

  @media screen and (min-width: 1360px) {
    .width-72 {
      min-width: 72px;
    }
  }
  @media screen and (min-width: 1735px) {
    .width-72 {
      min-width: 85px;
    }
    .width-66 {
      min-width: 85px;
    }
  }
`;

export const RightTableLastLineItem2 = styled.tr<{
  isHouseholdBased?: boolean;
}>`
  display: flex;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 5px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
    min-width: 83.5px;
  }
  td:first-child {
    min-width: 115px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-46 {
    min-width: 46px;
  }
  .width-47 {
    min-width: 47px;
  }
  .width-72,
  .width-72-block-2,
  .width-72-block-3-1,
  .width-72-block-3-2 {
    min-width: 80px;
  }
  .width-72-block-1 {
    min-width: 105px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66,
  .width-66-none,
  .width-66-middle,
  .width-66-none-block-1,
  .width-66-none-block-3 {
    /* min-width: 73px; */
    min-width: 80px;
  }
  .width-66-none-block-2 {
    min-width: 81px;
  }
  .width-66:last-child {
    border-right: none;
  }
  .width-183 {
    min-width: 184px !important;
    text-align: left !important;
    padding-left: 8px !important;
  }
  @media screen and (min-width: 1400px) {
    .width-72,
    /* .width-72-block-1, */
    .width-72-block-2,
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: 85px;
    }
    .width-66,
    .width-66-none,
    .width-66-middle,
    .width-66-none-block-1,
    .width-66-none-block-3 {
      /* min-width: 73px; */
      min-width: 85px;
    }
    .width-66-none-block-2 {
      min-width: 86px;
    }
  }
  @media screen and (min-width: 1625px) {
    .width-72 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) - 4px)"
          : "calc(((100% - 185px) / 12) - 4px)"}; */
    }
    .width-72-block-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 199px) / 15) - 3px)"
          : "calc(((100% - 199px) / 12) - 3px)"}; */
    }
    .width-72-block-2 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 208px) / 15) - 4.5px)"
          : "calc(((100% - 208px) / 12) - 4.5px)"}; */
    }
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 208px) / 15) - 3.5px)"
          : "calc(((100% - 208px) / 12) - 3.5px)"}; */
    }
    .width-66-none-block-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 9px)"
          : "calc(((100% - 185px) / 12) + 9px)"}; */
    }
    .width-66-none-block-2 {
      min-width: 106px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 9px)"
          : "calc(((100% - 185px) / 12) + 9px)"}; */
    }
    .width-66-none-block-3 {
      /* min-width: 105px;
      min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 185px) / 15) + 8px)"
          : "calc(((100% - 185px) / 12) + 8px)"}; */
    }
    .width-72-2 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 184px) / 15) - 6px)"
          : "calc(((100% - 184px) / 12) - 6px)"}; */
    }
    .width-72-3 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 184px) / 15) - 6px)"
          : "calc(((100% - 184px) / 12) - 6px)"}; */
    }

    .width-66-none-1 {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 178px) / 15) + 9px)"
          : "calc(((100% - 178px) / 12) + 9px)"}; */
    }
    .width-66-middle {
      min-width: 105px;
      /* min-width: 73px;
      width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc((100% - 182px) / 15)"
          : "calc((100% - 182px) / 12)"}; */
    }
    .width-66 {
      min-width: 105px;
      /* min-width: 73px;
      width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc((100% - 178px) / 15)"
          : "calc((100% - 178px) / 12)"}; */
    }
    .width-66:last-child {
      min-width: 105px;
      /* min-width: ${({ isHouseholdBased }) =>
        isHouseholdBased
          ? "calc(((100% - 173px) / 15) - 4px)"
          : "calc(((100% - 173px) / 12) - 4px)"}; */
    }
  }
  @media screen and (min-width: 1450px) {
    /* .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 195px) / 15) - 3px)"
        : "calc(((100% - 195px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 204px) / 15) - 4.5px)"
        : "calc(((100% - 204px) / 12) - 4.5px)"};
    }
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 208px) / 15) - 3.5px)"
        : "calc(((100% - 208px) / 12) - 3.5px)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 187px) / 15) + 9px)"
        : "calc(((100% - 187px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 178px) / 15) + 9px)"
        : "calc(((100% - 178px) / 12) + 9px)"};
    } */
  }
  @media screen and (min-width: 1475px) {
    /* .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 197px) / 15) - 4.5px)"
        : "calc(((100% - 197px) / 12) - 4.5px)"};
    }
  }
  @media screen and (min-width: 1500px) {
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 191px) / 15) - 4.5px)"
        : "calc(((100% - 191px) / 12) - 4.5px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 219px) / 15) - 3.5px)"
        : "calc(((100% - 219px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 210px) / 15) - 3.5px)"
        : "calc(((100% - 210px) / 12) - 3.5px)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 170px) / 15) + 8px)"
        : "calc(((100% - 170px) / 12) + 8px)"};
    } */
  }
  @media screen and (min-width: 1509px) {
    /* .width-72,
    .width-72-block-1,
    .width-72-block-2,
    .width-72-block-3-1,
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 193px) / 15)"
        : "calc((100% - 193px) / 12)"};
    }
    .width-66-none,
    .width-66-none-block-1,
    .width-66-none-block-2,
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 183px) / 15)"
        : "calc((100% - 183px) / 12)"};
    }
    .width-66:last-child {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 184px) / 15)"
        : "calc((100% - 184px) / 12)"};
    } */
  }
  @media screen and (min-width: 1530px) {
    /* .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 145px) / 15) - 3px)"
        : "calc(((100% - 145px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 140px) / 15) - 3.5px)"
        : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 130px) / 15) - 3.5px)"
        : "calc(((100% - 130px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 140px) / 15) - 3.5px)"
        : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 318px) / 15) + 9px)"
        : "calc(((100% - 318px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 225px) / 15) + 3px)"
        : "calc(((100% - 225px) / 12) + 3px)"};
    } */
  }
  @media screen and (min-width: 1550px) {
    /* .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 312px) / 15) + 9px)"
        : "calc(((100% - 312px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 222px) / 15) + 3px)"
        : "calc(((100% - 222px) / 12) + 3px)"};
    } */
  }
  @media screen and (min-width: 1575px) {
    /* .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 300px) / 15) + 9px)"
        : "calc(((100% - 300px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 216px) / 15) + 3px)"
        : "calc(((100% - 216px) / 12) + 3px)"};
    } */
  }
  @media screen and (min-width: 1600px) {
    /* .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 143px) / 15) - 3px)"
        : "calc(((100% - 143px) / 12) - 3px)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 125px) / 15) - 3.5px)"
        : "calc(((100% - 125px) / 12) - 3.5px)"};
    }
    .width-66-middle {
      width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 170px) / 15)"
        : "calc((100% - 170px) / 12)"};
    }
    .width-66-none-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 310px) / 15) + 9px)"
        : "calc(((100% - 310px) / 12) + 9px)"};
    }
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 234px) / 15) + 3px)"
        : "calc(((100% - 234px) / 12) + 3px)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 128px) / 15) - 3.5px)"
        : "calc(((100% - 128px) / 12) - 3.5px)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 140px) / 15) - 3.5px)"
        : "calc(((100% - 140px) / 12) - 3.5px)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc(((100% - 282px) / 15) + 7px)"
        : "calc(((100% - 282px) / 12) + 7px)"};
    } */
  }
  @media screen and (min-width: 1735px) {
    /* .width-72,
    .width-72-block-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 185px) / 15)"
        : "calc((100% - 185px) / 12)"};
    }
    .width-72-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 187px) / 15)"
        : "calc((100% - 187px) / 12)"};
    }
    .width-72-block-3-1 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 180px) / 15)"
        : "calc((100% - 180px) / 12)"};
    }
    .width-72-block-3-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 182px) / 15)"
        : "calc((100% - 182px) / 12)"};
    }
    .width-66,
    .width-66-none,
    .width-66-none-block-1,
    .width-66-none-block-2 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 178px) / 15)"
        : "calc((100% - 178px) / 12)"};
    }
    .width-66-none-block-3 {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 183px) / 15)"
        : "calc((100% - 183px) / 12)"};
    }
    .width-66-middle {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 188px) / 15)"
        : "calc((100% - 188px) / 12)"};
    }
    .width-66:last-child {
      min-width: ${({ isHouseholdBased }) =>
      isHouseholdBased
        ? "calc((100% - 184px) / 15)"
        : "calc((100% - 184px) / 12)"};
    } */
  }
  ${theme.media.laptopL} {
    /* .width-47 {
      min-width: 43px;
    } */
    /* .width-72 {
      min-width: 72px;
    } */
  }
`;

export const RightTableLastLineItem3 = styled.tr`
  display: flex;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #3b3b3b;
  border-left: 1px solid #cccccc;
  /* border-right: 1px solid #cccccc; */
  div,
  td {
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    text-align: right;
    padding: 5px 4px 5px 5px;
  }
  /* div:last-child {
    border-right: none;
  } */
  div:first-child,
  td:first-child {
    text-align: center;
    padding-left: 4px;
    min-width: 83.5px;
  }
  td:first-child {
    min-width: 115px;
  }
  .width-36 {
    min-width: 36px;
  }
  .width-40 {
    min-width: 40px;
  }
  .width-41 {
    min-width: 41px;
  }
  .width-46 {
    min-width: 46px;
  }
  .width-47 {
    min-width: 47px;
  }
  .width-72 {
    min-width: 64px;
  }
  .width-72-single {
    min-width: 86px;
  }
  .width-44 {
    min-width: 45px;
  }
  .width-112 {
    min-width: 112px;
  }
  .width-124 {
    min-width: 124px;
  }
  .width-66 {
    min-width: 73px;
  }
  .width-183 {
    min-width: 184px !important;
    text-align: center !important;
    padding-left: 8px !important;
  }
  .width-126 {
    min-width: 127px;
  }
  @media screen and (min-width: 1360px) {
    .width-72 {
      min-width: 72px;
    }
  }
  @media screen and (min-width: 1735px) {
    .width-72 {
      min-width: 85px;
    }
    .width-66 {
      min-width: 85px;
    }
  }
`;

export const TableWrapperRef = styled.div`
  width: max-content;
  @media screen and (min-width: 1400px) {
    width: 100%;
  }
`;
